// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* TODO: Should be using css modules now */
.FF-FieldLabel {
  white-space: break-spaces;
  overflow: visible;
}

.FF-FieldLabel-html {
  display: block;
  overflow: visible;
  width: 100%;
}

/*
 * Restore list markers for sanitized HTML labels.
 * Use list-style-position: inside so bullets are not clipped by InputField / flex
 * ancestors that use overflow: hidden on the label row.
 */
.FF-FieldLabel ul,
.FF-FieldLabel-html ul {
  list-style-type: disc !important;
  list-style-position: inside;
  margin: 0.25rem 0;
  padding-inline-start: 1.25rem;
}

.FF-FieldLabel ol,
.FF-FieldLabel-html ol {
  list-style-type: decimal !important;
  list-style-position: inside;
  margin: 0.25rem 0;
  padding-inline-start: 1.25rem;
}

.FF-FieldLabel li,
.FF-FieldLabel-html li {
  display: list-item !important;
}

.FF-FieldLabel ul > li,
.FF-FieldLabel-html ul > li {
  list-style-type: disc !important;
}

.FF-FieldLabel ol > li,
.FF-FieldLabel-html ol > li {
  list-style-type: decimal !important;
}

/* Tables inside HTML labels (DA) */
.FF-FieldLabel table,
.FF-FieldLabel-html table {
  display: table;
  border-collapse: collapse;
  width: 100%;
  max-width: 100%;
  margin: 0.25rem 0;
}

.FF-FieldLabel thead,
.FF-FieldLabel-html thead {
  display: table-header-group;
}

.FF-FieldLabel tbody,
.FF-FieldLabel-html tbody {
  display: table-row-group;
}

.FF-FieldLabel tfoot,
.FF-FieldLabel-html tfoot {
  display: table-footer-group;
}

.FF-FieldLabel tr,
.FF-FieldLabel-html tr {
  display: table-row;
}

.FF-FieldLabel th,
.FF-FieldLabel td,
.FF-FieldLabel-html th,
.FF-FieldLabel-html td {
  display: table-cell;
  border: 1px solid var(--color-border-secondary-subtlest, #cfd9e9);
  padding: 0.25rem 0.5rem;
  text-align: start;
  vertical-align: top;
}

.FF-FieldLabel th,
.FF-FieldLabel-html th {
  font-weight: var(--font-weight-semibold, 600);
}

.FF-FieldLabel--isReadOnly,
.FF-FieldLabel--isReadOnly input {
  color: var(--color-foreground-neutral-subtle, #717385);
}

/* ===========  Readonly Styles  ============= */
.FF-FieldValue--isReadOnly,
.FF-FieldValue--isReadOnly:disabled {
  color: var(--color-foreground-neutral-medium, #4a4c59);
}
`, "",{"version":3,"sources":["webpack://./src/shared/components/FieldLabel/FieldLabel.css"],"names":[],"mappings":"AAAA,0CAA0C;AAC1C;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,WAAW;AACb;;AAEA;;;;EAIE;AACF;;EAEE,gCAAgC;EAChC,2BAA2B;EAC3B,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;;EAEE,mCAAmC;EACnC,2BAA2B;EAC3B,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA,mCAAmC;AACnC;;EAEE,cAAc;EACd,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;;;EAIE,mBAAmB;EACnB,iEAAiE;EACjE,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;;EAEE,6CAA6C;AAC/C;;AAEA;;EAEE,sDAAsD;AACxD;;AAEA,gDAAgD;AAChD;;EAEE,sDAAsD;AACxD","sourcesContent":["/* TODO: Should be using css modules now */\n.FF-FieldLabel {\n  white-space: break-spaces;\n  overflow: visible;\n}\n\n.FF-FieldLabel-html {\n  display: block;\n  overflow: visible;\n  width: 100%;\n}\n\n/*\n * Restore list markers for sanitized HTML labels.\n * Use list-style-position: inside so bullets are not clipped by InputField / flex\n * ancestors that use overflow: hidden on the label row.\n */\n.FF-FieldLabel ul,\n.FF-FieldLabel-html ul {\n  list-style-type: disc !important;\n  list-style-position: inside;\n  margin: 0.25rem 0;\n  padding-inline-start: 1.25rem;\n}\n\n.FF-FieldLabel ol,\n.FF-FieldLabel-html ol {\n  list-style-type: decimal !important;\n  list-style-position: inside;\n  margin: 0.25rem 0;\n  padding-inline-start: 1.25rem;\n}\n\n.FF-FieldLabel li,\n.FF-FieldLabel-html li {\n  display: list-item !important;\n}\n\n.FF-FieldLabel ul > li,\n.FF-FieldLabel-html ul > li {\n  list-style-type: disc !important;\n}\n\n.FF-FieldLabel ol > li,\n.FF-FieldLabel-html ol > li {\n  list-style-type: decimal !important;\n}\n\n/* Tables inside HTML labels (DA) */\n.FF-FieldLabel table,\n.FF-FieldLabel-html table {\n  display: table;\n  border-collapse: collapse;\n  width: 100%;\n  max-width: 100%;\n  margin: 0.25rem 0;\n}\n\n.FF-FieldLabel thead,\n.FF-FieldLabel-html thead {\n  display: table-header-group;\n}\n\n.FF-FieldLabel tbody,\n.FF-FieldLabel-html tbody {\n  display: table-row-group;\n}\n\n.FF-FieldLabel tfoot,\n.FF-FieldLabel-html tfoot {\n  display: table-footer-group;\n}\n\n.FF-FieldLabel tr,\n.FF-FieldLabel-html tr {\n  display: table-row;\n}\n\n.FF-FieldLabel th,\n.FF-FieldLabel td,\n.FF-FieldLabel-html th,\n.FF-FieldLabel-html td {\n  display: table-cell;\n  border: 1px solid var(--color-border-secondary-subtlest, #cfd9e9);\n  padding: 0.25rem 0.5rem;\n  text-align: start;\n  vertical-align: top;\n}\n\n.FF-FieldLabel th,\n.FF-FieldLabel-html th {\n  font-weight: var(--font-weight-semibold, 600);\n}\n\n.FF-FieldLabel--isReadOnly,\n.FF-FieldLabel--isReadOnly input {\n  color: var(--color-foreground-neutral-subtle, #717385);\n}\n\n/* ===========  Readonly Styles  ============= */\n.FF-FieldValue--isReadOnly,\n.FF-FieldValue--isReadOnly:disabled {\n  color: var(--color-foreground-neutral-medium, #4a4c59);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
